import { useAtom } from 'jotai';
import type { ImageSettingsT } from '../../labelling/providers/stage-provider';
import { imageSettingsAtom } from '../atoms/image-settings-atoms';
export const useImageSettings = (): [ImageSettingsT, (value: ImageSettingsT | ((prev: ImageSettingsT) => ImageSettingsT)) => void] => {
  const [imageSettings, setImaeSettings] = useAtom(imageSettingsAtom);
  return [imageSettings, setImaeSettings];
};